<!-- Home — internal Angular route -->
<a
    class="mst-bottomMenu__item stack col xCenter yCenter gap6"
    routerLink="/home"
    [class.-active]="activeSection() === 'home'"
    aria-label="Home"
>
    <i class="mst-icon-msb-logo-symbol mst-bottomMenu__icon" aria-hidden="true"></i>
    <span class="mst-bottomMenu__label">Home</span>
</a>

<a
    class="mst-bottomMenu__item stack col xCenter yCenter gap6"
    routerLink="/msb4you"
    [class.-active]="activeSection() === 'msb4you'"
    aria-label="MSB4You"
>
    <i class="mst-icon-video-playlist mst-bottomMenu__icon" aria-hidden="true"></i>
    <span class="mst-bottomMenu__label">MSB4You</span>
</a>

<!-- Shop — internal route in PWA, external WordPress otherwise -->
@if (isStandaloneMode) {
    <a
        class="mst-bottomMenu__item stack col xCenter yCenter gap6"
        routerLink="/shop"
        [class.-active]="activeSection() === 'shop'"
        aria-label="Shop"
    >
        <i class="mst-icon-shopping-bag mst-bottomMenu__icon" aria-hidden="true"></i>
        <span class="mst-bottomMenu__label">Shop</span>
    </a>
} @else {
    <a
        class="mst-bottomMenu__item stack col xCenter yCenter gap6"
        [href]="wpUrl + 'shop'"
        [class.-active]="activeSection() === 'shop'"
        aria-label="Shop"
    >
        <i class="mst-icon-shopping-bag mst-bottomMenu__icon" aria-hidden="true"></i>
        <span class="mst-bottomMenu__label">Shop</span>
    </a>
}

<!-- Programmi — internal route in PWA, external WordPress otherwise -->
@if (isStandaloneMode) {
    <a
        class="mst-bottomMenu__item stack col xCenter yCenter gap6"
        routerLink="/programs"
        [class.-active]="activeSection() === 'programs'"
        aria-label="Programmi"
    >
        <i class="mst-icon-checklist mst-bottomMenu__icon" aria-hidden="true"></i>
        <span class="mst-bottomMenu__label">Programmi</span>
    </a>
} @else {
    <a
        class="mst-bottomMenu__item stack col xCenter yCenter gap6"
        [href]="wpUrl + 'programs-woman'"
        [class.-active]="activeSection() === 'programs'"
        aria-label="Programmi"
    >
        <i class="mst-icon-checklist mst-bottomMenu__icon" aria-hidden="true"></i>
        <span class="mst-bottomMenu__label">Programmi</span>
    </a>
}

<!-- My Area — internal Angular route (authenticated section) -->
<a
    class="mst-bottomMenu__item stack col xCenter yCenter gap6"
    routerLink="/training"
    [class.-active]="activeSection() === 'myarea'"
    aria-label="My area"
>
    <i class="mst-icon-profile-circle mst-bottomMenu__icon" aria-hidden="true"></i>
    <span class="mst-bottomMenu__label">My area</span>
</a>
